import React from 'react'
import { Row, Col } from 'antd'
import CatCard from './CatCard'

export default function CardRow(props) {
  let listCards = null;
  if(props.data){
     listCards = props.data.map((item, index) =>{
      return (
      <Col flex="0 1 350px" style={{ marginTop: '15px', margin: '5px', justifyContent: 'center' }} key={item.name}>
      <CatCard item={item} admin={props.admin} />
      </Col>
      )
    }
    );
  }
  console.log(listCards)
  return (
    <Row className="row" style={{ justifyContent: 'space-evenly' }}>
      {listCards}
  </Row>
  )
}
